import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';
import conf from '../_models/conf.json';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private confurl = conf.urlApidev; //dev
  // private confurl = conf.urlApilocal; // local
  // private confurl = conf.urlApiprod; //prod

  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'referer-policy': 'no-referrer-when-downgrade',
    }),
  };

  DefaulthttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'referer-policy': 'no-referrer-when-downgrade',
      }),
    };
  }

  // _httpOptions()
  // {

  //   //const currentUser = this.authenticationService.currentUserValue;
  //   //console.log(currentUser);
  //   //const isLoggedIn = currentUser && currentUser.access_token;
  //   const isLoggedIn = true;

  //   if ( isLoggedIn )
  //   {
  //     return {
  //           headers: new HttpHeaders({
  //             'Content-Type': 'application/json',
  //             'Authorization': 'Bearer 5Jg4zwwA484k1n52GUcNCWVX70w0Citk',
  //             'referer-policy': 'no-referrer-when-downgrade'
  //           })
  //         };
  //   }else{
  //     return {
  //           headers: new HttpHeaders({
  //             'Content-Type': 'application/json',
  //             'referer-policy': 'no-referrer-when-downgrade'
  //           })
  //         };
  //   }
  // }
  _outhttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer hl-7Gx0vTsVYQORludsgf_ACydUrsNFu',
        'referer-policy': 'no-referrer-when-downgrade',
      }),
    };
  }

  _billhttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/xhtml+xml',
        Authorization: 'Bearer hl-7Gx0vTsVYQORludsgf_ACydUrsNFu',
        'referer-policy': 'no-referrer-when-downgrade',
      }),
    };
  }

  // _UploadHttpOptions()
  // {
  //   //const currentUser = this.authenticationService.currentUserValue;
  //     //console.log(currentUser);
  //     //const isLoggedIn = currentUser && currentUser.access_token;
  //     const isLoggedIn = true;

  //     if ( isLoggedIn )
  //     {
  //       return {
  //             //reportProgress: true,
  //             //observe: 'events',
  //             headers: new HttpHeaders({
  //               'Authorization': 'Bearer 5Jg4zwwA484k1n52GUcNCWVX70w0Citk',
  //             })
  //           };
  //     }else{
  //       return {
  //             headers: new HttpHeaders({
  //               'Content-Type': 'multiproject/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
  //               'referer-policy': 'no-referrer-when-downgrade'
  //             })
  //           };
  //     }
  // }

  GetProvince(): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'storeplaybox/masters/province',
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetCity(id): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'storeplaybox/masters/city?id=' + id,
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetDistrict(id): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'storeplaybox/masters/district?id=' + id,
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetSubdistrict(id): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'storeplaybox/masters/subdistrict?id=' + id,
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetPostalcode(data): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'storeplaybox/masters/postalcode',
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetProduct(qs): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'storeplaybox/masters/product' + qs,
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetStoreShop(qs): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'storeplaybox/masters/shop?' + qs,
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetStoreKurir(qs): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'storeplaybox/masters/marketplacekurir?' + qs,
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }
  GetStoreShippingtype(qs): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'storeplaybox/masters/marketplacejenispengiriman?' + qs,
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetStoreLokasigudang(qs): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'storeplaybox/masters/marketplacelokasigudang?' + qs,
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  PostCheckout(data): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'storeplaybox/actions/checkout',
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // web activation
  Checkuser(data: any): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'storeplaybox/actions/checkuser',
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }
  Activationlandingpage(data: any): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'storeplaybox/actions/atvactivelandingpage',
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // web purchase
  GetWPSearch(data: any): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'webpurchase/actions/search',
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetWPProdaddon(data: any): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'webpurchase/actions/productaddon',
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  PostWPCheckout(data: any): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'webpurchase/actions/checkout',
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  PostWPWaNotif(data: any): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'webpurchase/actions/wanotif',
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  bill(data: any): Observable<any> {
    return this.http
      .post<any>(
        'https://billing.mncplay.id/main/billinfo',
        JSON.stringify(data),
        this._billhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetOngkirsicepat(data): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'master/ekspedisis/sicepattarif',
        JSON.stringify(data),
        this.DefaulthttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetOngkirtiki(data): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'master/ekspedisis/tiki',
        JSON.stringify(data),
        this.DefaulthttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // landingpage component module
  // profile
  UpdateProfile(id: any, data: any): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'landingpage/profiles/updateprofile/' + id,
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }
  Landingpageprofile(params: any): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'landingpage/profiles/profile/' + params,
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }
  Landingpagepackagedetail(params1: any, params2: any): Observable<any> {
    return this.http
      .get<any>(
        this.confurl +
        'landingpage/purchases/purchasepackage/' +
        params1 +
        '/' +
        params2,
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }
  Landingpagecheckout(data: any): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'landingpage/purchases/checkout',
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }
  Landingpagewanotif(data: any): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'landingpage/purchases/wanotif',
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // promo bank
  GetPromobank(params: any): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'promo/promobanks/getpromo/' + params,
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }
  GetAllpromobank(): Observable<any> {
    return this.http
      .get<any>(
        this.confurl + 'promo/promobanks/getallpromo',
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // nextsys
  PostCheckoutNextsys(data): Observable<any> {
    return this.http
      .post<any>(
        this.confurl + 'storenextsys/actions/checkout',
        JSON.stringify(data),
        this._outhttpOptions()
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // Error handling
  errorHandl(error) {
    console.log(error);
    return throwError(error);

    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
